import { useEffect } from "react";

const SITE = "https://99tests.com";
const DEFAULT_DESC = "Real-device app and browser testing in India. Fixed price from ₹9,999, verified report in 3 business days.";
const DEFAULT_OG_IMAGE = "/assets/og-99tests.png";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export function useSeo({ title, fullTitle = null, description = DEFAULT_DESC, path = "/", noindex = false, jsonld = null, image = null, alternates = null, lang = "en" }) {
  useEffect(() => {
    const full = fullTitle ? fullTitle : (title ? `${title} — 99tests` : "99tests — Real-Device Testing for AI-Generated Tests");
    document.title = full;
    document.documentElement.lang = lang;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large");
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", SITE + path);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("property", "og:type", "website");
    const img = image || DEFAULT_OG_IMAGE;
    const abs = img.startsWith("http") ? img : SITE + img;
    setMeta("property", "og:image", abs);
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:image", abs);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = SITE + (noindex ? "/" : path);

    document.querySelectorAll('link[data-seo-alt]').forEach((el) => el.remove());
    if (alternates) {
      alternates.forEach((alt) => {
        const el = document.createElement("link");
        el.rel = "alternate";
        el.hreflang = alt.hreflang;
        el.href = SITE + alt.path;
        el.setAttribute("data-seo-alt", "1");
        document.head.appendChild(el);
      });
    }

    document.querySelectorAll("script[data-seo-jsonld]").forEach((el) => el.remove());
    const blocks = jsonld ? (Array.isArray(jsonld) ? jsonld : [jsonld]) : [];
    blocks.forEach((block, i) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = `seo-jsonld-${i}`;
      el.setAttribute("data-seo-jsonld", "1");
      el.textContent = JSON.stringify(block);
      document.head.appendChild(el);
    });
    return () => {
      document.querySelectorAll("script[data-seo-jsonld]").forEach((el) => el.remove());
      document.querySelectorAll('link[data-seo-alt]').forEach((el) => el.remove());
    };
  }, [title, fullTitle, description, path, noindex, jsonld, alternates, image, lang]);
}
